export class LotNoReq{
    lotNumber?:string;
    constructor(
        lotnumber?:string
    ){
        this.lotNumber = lotnumber
    }
}